/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Partner_Managed_TitleInputs */



/**
* | output |
* | --- |
* | "Managed by partner" |
*
* @param {Sub_Partner_Managed_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_partner_managed_title = /** @type {((inputs?: Sub_Partner_Managed_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Partner_Managed_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vom Partner verwaltet")
	return /** @type {LocalizedString} */ ("Managed by partner")
});